"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../../../material/index");

var _dropdownitemcontrols = _interopRequireDefault(require("./dropdownitemcontrols/dropdownitemcontrols"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _dropdownitem_styles = _interopRequireDefault(require("./dropdownitem_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/* ========== ~~~~~~~~~~ EXPORT : DROPFILTER : DROPDOWN ITEM ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_dropdownitem_styles.default)(function (props) {
  var itemName = props.itemName,
      value = props.value,
      searchTerm = props.searchTerm,
      itemSelected = props.itemSelected,
      isUniqueName = props.isUniqueName,
      editable = props.editable,
      inEditState = props.inEditState; // Hide the item on search if it doesn't contain the search term

  if (!!searchTerm && !itemName.toLowerCase().includes(searchTerm.toLowerCase())) return null;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var _useState3 = (0, _react.useState)(itemName),
      _useState4 = _slicedToArray(_useState3, 2),
      inputItemName = _useState4[0],
      setInputItemName = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isNameValid = _useState6[0],
      setIsNameValid = _useState6[1];

  var triggerEdit = function triggerEdit() {
    return setEditMode(!editMode);
  };

  var handleSave = function handleSave() {
    // Do nothing if name is not valid
    if (!isNameValid) {
      return null;
    } // Stop editing if name is the same as it was


    if (itemName === inputItemName) {
      setEditMode(false);
      return null;
    } // Invalidate the field if the already exists


    if (!isUniqueName(inputItemName)) {
      setIsNameValid(false);
      return null;
    } // Save the name if all checks are passed


    setEditMode(false);
    props.onItemUpdate(value, inputItemName);
  };

  var handleCancel = function handleCancel() {
    setEditMode(false);
    setInputItemName(itemName);
  };

  var handleDelete = function handleDelete() {
    setEditMode(false);
    props.onItemDelete(value);
  };

  var handleClick = function handleClick() {
    props.itemSelected ? props.handleDeselect(props.value) : props.handleSelect(props.value);
  };

  var renderItemText = function renderItemText() {
    return editMode ? renderEditableField() : renderNonEditableField();
  };

  var handleChange = function handleChange(event) {
    var name = event.target.value;
    var isValid = checkNameValidity(name);
    if (isValid !== isNameValid) setIsNameValid(isValid);
    setInputItemName(name);
  };

  var checkNameValidity = function checkNameValidity(name) {
    return /^(?!\s)[A-Za-z0-9'\.\-\s\,]{1,255}$/.test(name);
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      handleSave();
    }
  };

  var renderNonEditableField = function renderNonEditableField() {
    var beginningText = itemName.slice(0, itemName.toLowerCase().indexOf(searchTerm.toLowerCase()));
    var highlightedText = itemName.slice(itemName.toLowerCase().indexOf(searchTerm.toLowerCase()), itemName.toLowerCase().indexOf(searchTerm.toLowerCase()) + searchTerm.length);
    var endingText = itemName.slice(itemName.toLowerCase().indexOf(searchTerm.toLowerCase()) + searchTerm.length, itemName.length);
    return _react.default.createElement("div", {
      onClick: handleClick,
      className: "dropdownitemtext"
    }, _react.default.createElement("span", null, beginningText), _react.default.createElement("span", {
      className: "highlight"
    }, highlightedText), _react.default.createElement("span", null, endingText));
  };

  var renderEditableField = function renderEditableField() {
    return _react.default.createElement("input", {
      type: "text",
      className: "dropdowniteminput valid-".concat(isNameValid),
      value: inputItemName,
      onChange: handleChange,
      onKeyDown: handleKeyDown
    });
  };

  var renderCheck = function renderCheck() {
    return _react.default.createElement("div", {
      className: "dropdownitemcheck",
      onClick: handleClick
    }, _react.default.createElement(_index.Icon, {
      name: "check"
    }));
  };

  return _react.default.createElement("div", {
    className: "dropdownitem ".concat(props.classes.dropdownitem, " active-").concat(itemSelected, " name-").concat(itemName)
  }, renderCheck(), renderItemText(), editable && inEditState && _react.default.createElement(_dropdownitemcontrols.default, {
    onEdit: triggerEdit,
    onSave: handleSave,
    onCancel: handleCancel,
    onDelete: handleDelete,
    editMode: editMode
  }));
});

exports.default = _default;